/*
  eGURU G4③ — hiệu ứng ảnh sản phẩm bay vào giỏ khi thêm hàng.
  Bắt ở giai đoạn capture trên form add-to-cart để chạy trước khi theme gửi fetch,
  vì lúc đó ảnh nguồn còn nguyên vị trí trên màn hình.
*/
(function () {
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function findSourceImage(form) {
    // Thẻ sản phẩm / popup thêm nhanh: ảnh nằm ngay trong thẻ.
    var card = form.closest('.card-wrapper, .quick-add-modal');
    if (card) {
      var cardImg = card.querySelector('.card__media img, .card__inner img, img');
      if (cardImg) return cardImg;
    }
    // Trang sản phẩm: form nằm trong cột phải (product-info) còn ảnh ở cột trái,
    // nên phải trèo lên tận .product rồi mới dò — closest() dừng ở product-info.
    var product = form.closest('.product') || document;
    return (
      product.querySelector('.product__media img, .product__media-wrapper img') ||
      document.querySelector('.product__media img, .product__media-wrapper img')
    );
  }

  function findCartTarget() {
    return (
      document.getElementById('cart-icon-bubble') ||
      document.querySelector('.header__icon--cart, a[href$="/cart"]')
    );
  }

  function fly(img, target) {
    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var size = Math.min(from.width, 120);
    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'egr-fly';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    ghost.style.left = from.left + (from.width - size) / 2 + 'px';
    ghost.style.top = from.top + (from.height - size) / 2 + 'px';
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    requestAnimationFrame(function () {
      ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.18)';
      ghost.style.opacity = '0.25';
    });

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      ghost.remove();
      target.classList.add('egr-cart-pop');
      setTimeout(function () { target.classList.remove('egr-cart-pop'); }, 500);
    };
    ghost.addEventListener('transitionend', finish);
    setTimeout(finish, 900);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var target = findCartTarget();
    var img = findSourceImage(form);
    if (target && img) fly(img, target);
  }, true);

  // Nút thêm nhanh trên thẻ sản phẩm không phải lúc nào cũng submit form
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quick-add__submit, button[name="add"]');
    if (!btn || btn.closest('form[action*="/cart/add"]')) return;
    var target = findCartTarget();
    var scope = btn.closest('.card-wrapper, .product');
    var img = scope && scope.querySelector('img');
    if (target && img) fly(img, target);
  }, true);
})();
